import {
    NavController,
    NavParams,
    App,
    ModalController,
    ViewController,
    ToastController,
  } from "ionic-angular";
  import { Storage } from "@ionic/storage";
  import { Component, OnInit, Input, ViewChild } from "@angular/core";
  
  import { AuthProvider } from "../../../../../providers/auth/auth";
  import { EmployeeRhProvider } from "../../../../../providers/employeerh/employeerh";
  import { GoalRhProvider } from "../../../../../providers/goals/goals";
import { SignaturePad } from "angular2-signaturepad";
  
  @Component({
    selector: "page-rh-goals-sign",
    templateUrl: "goals-sign-list.html",
  })
  export class RhGoalsSignList implements OnInit {
    
    list:any = null;
    isUserSigning:boolean = false;

    signature:string = null;

    @ViewChild(SignaturePad) signaturePad: SignaturePad;
  
    private signaturePadOptions: Object = {
      'minWidth': 3,
      'canvasWidth': 300,
      'canvasHeight': 300,
      'dotSize' : .5
    };

    constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public storageProvider: Storage,
      public app: App,
      public authProvider: AuthProvider,
      public employeeRhProvider: EmployeeRhProvider,
      public viewCtrl: ViewController,
      public toastCtrl: ToastController,
      private goalRhProvider: GoalRhProvider
    ) {
      this.list = this.navParams.get('list');
    }
  
    ngOnInit() {
      this.loadDatas();
    }
  
    loadDatas() {
      console.log(this.list)
    }

    drawComplete() {
      this.signature = this.signaturePad.toDataURL();
    }

    clearCanvas(){
      this.signaturePad.clear();
      this.signature = null;
    }

    submit(){
      if(this.signature !== null){
        this.goalRhProvider.signList(this.signature, this.list.listToSign.id).subscribe((res) => {
          if(res.success){
            let toast = this.toastCtrl.create({ message: "Vous avez signé vos objectifs", duration: 6000, position: 'top'});
            toast.present();
            this.dismiss();
          }
        })
      }
    }
  
  
    // Modal ctrl
    dismiss() {
      this.viewCtrl.dismiss();
    }
  }
  


// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-goals/goals-sign-list/goals-sign-list.ts